export default "/assets/images/app-rooms-video.77644ae61ef03576.mp4";